import React, { useState, useEffect ,useMemo} from 'react';
import { TextField, Paper, Typography, Box } from '@mui/material';
import { GroupeBien } from '../../models/models';
import { createGroupeBien, setSelectedGroupeBien,deleteGroupeBien } from '../../reduxStore/GroupeBienSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../reduxStore/Store';
import { useSnackbar } from '../../components/SnackbarProvider';
import MyButton from '../MyButton';
import { ButtonType } from '../../constants/enums';

interface GroupeBienFormProps {
  onCancel: () => void;
}


const GroupeBienForm: React.FC<GroupeBienFormProps> = ({ onCancel }) => {

  const initialiseFormData = useMemo(() => ({
    id: -1,
    nom: '',
    description: '',
    nombre_biens: 0,
    surface_totale: null,
  }), []);

  const { selectedGroupeBien } = useSelector((state: any) => state.GropueBienSlice); // Vérifie bien le nom du slice
  const [formData, setFormData] = useState<GroupeBien>(initialiseFormData);

  useEffect(() => {
    if (selectedGroupeBien) {
      setFormData({
        id: selectedGroupeBien.id,
        nom: selectedGroupeBien.nom,
        description: selectedGroupeBien.description,
        nombre_biens: selectedGroupeBien.nombre_biens || 0,
        surface_totale: selectedGroupeBien.surface_totale || null,
      });
    } else {
      setFormData(initialiseFormData);
    }
  }, [initialiseFormData, selectedGroupeBien]);

  const dispatch = useDispatch<AppDispatch>();
  const { showSnackbar } = useSnackbar();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'nombre_biens' || name === 'surface_totale' ? Number(value) : value,
    }));
  };

  const handleSubmit = async () => {
    try {
      await dispatch(createGroupeBien(formData)).unwrap();
      showSnackbar('Opération réussie!', 'success');
      dispatch(setSelectedGroupeBien(null));
      setFormData(initialiseFormData);
    } catch (error) {
      showSnackbar(error as string || 'Échec de l\'enregistrement', 'error');
    }
  };

    const handleDelete = async (gb: GroupeBien) => {
      if (selectedGroupeBien) {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce groupe de bien ?")) {
          try {
            await dispatch(deleteGroupeBien(gb.id ?? 0)).unwrap();
            showSnackbar("Groupe de biens supprimé!", "success");
            dispatch(setSelectedGroupeBien(null));
            setFormData(initialiseFormData);
          } catch (error) {
            showSnackbar(error as string || "Échec de la suppression", "error");
          }
        }
      }
  
    }

  return (
    <Paper elevation={3} sx={{ padding: 2, marginBottom: 2 }}>
      <Typography variant="h6" gutterBottom>
        {selectedGroupeBien ? 'Modifier un Groupe De Bien' : 'Ajouter un Groupe de Bien'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box display="grid" gridTemplateColumns="repeat(1, 1fr)" gap={2}>
          <TextField name="nom" label="Nom" value={formData.nom} onChange={handleChange} fullWidth size="small" />
          <TextField name="description" label="Description" value={formData.description || ''} onChange={handleChange} fullWidth size="small" />
          <TextField
            name="nombre_biens"
            label="Nombre de biens"
            type="number"
            value={formData.nombre_biens}
            onChange={handleChange}
            fullWidth
            size="small"
          />
          <TextField
            name="surface_totale"
            label="Surface totale (m²)"
            type="number"
            value={formData.surface_totale || ''}
            onChange={handleChange}
            fullWidth
            size="small"
          />
        </Box>
        <Box mt={2} display="flex" justifyContent="space-between">
        <div>
            <MyButton actionType={ButtonType.INSERT} variant="contained" onClick={handleSubmit}>
              {selectedGroupeBien ? 'Modifier' : 'Ajouter'}
            </MyButton>
            <MyButton actionType={ButtonType.DELETE} variant="outlined" onClick={() => handleDelete(selectedGroupeBien)}>
              Delete
            </MyButton>
            <MyButton actionType={ButtonType.CANCEL} variant="outlined" onClick={onCancel}>
              Cancel
            </MyButton>
          </div>
        </Box>
      </form>
    </Paper>
  );
};

export default GroupeBienForm;
